import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizenScoresIndicatorC2Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export type DetailedCitizenScoresIndicatorC2Data = {
	id: number;
	cpf?: string;
	cns?: string;
	birthdate: string;
	fullName: string;
	healthUnitId: number;
	healthTeamId: number;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	firstAttendanceStatus: "finished" | "pending" | "lost";
	nineAttendancesStatus: "finished" | "pending" | "lost";
	nineWeightAndHeightMetricsRegistersStatus: "finished" | "pending" | "lost";
	twoHomeVisitsStatus: "finished" | "pending" | "lost";
	vaccinationsStatus: "finished" | "pending" | "lost";
	score: number;
};

export async function getDetailedCitizensScoresIndicatorC2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenScoresIndicatorC2Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenScoresIndicatorC2Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c2/detailed-citizens-scores`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenScoresIndicatorC2Data>();
}
